/**
 * Seasonal Grams — <sg-countdown> free-gift countdown element.
 * Ticks a labeled days/hours/mins/secs countdown to the `end` attribute (epoch ms). The days unit
 * shows only when >= 1 day remains. Used by the free-gift popup and cart banner via
 * snippets/free-gift-countdown.liquid. Distinct from the sale Countdown banner's `countdown-timer`
 * (assets/countdown-banner.js), which takes a fixed calendar date.
 */
if (!customElements.get('sg-countdown')) {
  function sgPad2(n) { return (n < 10 ? '0' : '') + n; }

  class SgCountdown extends HTMLElement {
    static get observedAttributes() { return ['end']; }

    connectedCallback() { this.start(); }
    disconnectedCallback() { this.stop(); }
    attributeChangedCallback(name) {
      if (name === 'end' && this.isConnected) { this.start(); }
    }

    // Idempotent: always clears any prior interval first, so overlapping
    // connected/attributeChanged reactions can't create duplicate tickers.
    start() {
      this.stop();
      var end = parseInt(this.getAttribute('end'), 10);
      if (!end || isNaN(end)) { return; }
      this._end = end;
      this.update();
      var self = this;
      this._interval = setInterval(function () { self.update(); }, 1000);
    }

    stop() {
      if (this._interval) { clearInterval(this._interval); this._interval = null; }
    }

    update() {
      var diff = this._end - Date.now();
      if (diff < 0) { diff = 0; }
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      this.setNum('[data-d]', d);
      this.setNum('[data-h]', sgPad2(h));
      this.setNum('[data-m]', sgPad2(m));
      this.setNum('[data-s]', sgPad2(s));
      var daysUnit = this.querySelector('[data-unit-days]');
      if (daysUnit) { daysUnit.hidden = d <= 0; }   // days only when >= 1 day remains
      if (diff <= 0) { this.stop(); }
    }

    setNum(sel, val) {
      var el = this.querySelector(sel);
      if (el) { el.textContent = val; }
    }
  }

  customElements.define('sg-countdown', SgCountdown);
}
